import { render, staticRenderFns } from "./formRegulatoryUpdates.vue?vue&type=template&id=78d5157a&"
import script from "./formRegulatoryUpdates.vue?vue&type=script&lang=js&"
export * from "./formRegulatoryUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports